import { ComponentDefinition } from '@wix/editor-platform-sdk-types';
import { ExtendedPlatformContext } from '../../../../../types/platformApi';
import { CompRef } from '@wix/document-services-types';

const CLASSIC_EDITOR = 'CLASSIC';
const RESPONSIVE_EDITOR = 'STUDIO';
const X_MARGIN = 45;
export const WIDTH_DEFAULT_LIGHTBOX_CONTAINER = 340;

const closeButtonHandler: Record<string, Function> = {
  [CLASSIC_EDITOR]: getClassicCloseButton,
  [RESPONSIVE_EDITOR]: getResponsiveCloseButton,
};

function getClassicCloseButton(
  context: ExtendedPlatformContext,
  lightboxContainerCompRef: CompRef,
) {
  const containerSizeEditor = context.documentServices.components.layout.get(
    lightboxContainerCompRef,
  );
  return createCloseButtonClassic(
    containerSizeEditor?.width ?? WIDTH_DEFAULT_LIGHTBOX_CONTAINER,
  );
}

function getResponsiveCloseButton(
  _context: ExtendedPlatformContext,
  _lightboxContainerCompRef: CompRef,
) {
  return closeButton;
}

export function getCloseButton(
  context: ExtendedPlatformContext,
  lightboxContainerCompRef: CompRef,
) {
  const editorType =
    context.platformApiMethods.editor.info.getHostType() ?? CLASSIC_EDITOR;
  return closeButtonHandler[editorType](context, lightboxContainerCompRef);
}

function createCloseButtonClassic(width: number): ComponentDefinition {
  return {
    ...closeButton,
    layout: {
      ...closeButton.layout,
      x: width - X_MARGIN,
    },
  };
}

export const closeButton: ComponentDefinition = {
  type: 'Component',
  componentType: 'wysiwyg.viewer.components.PopupCloseIconButton',
  skin: 'svgshape.v2.Svg_9a8686831e874878a55a90925c0feb6c',
  layout: {
    x: 0,
    y: 10,
    fixedPosition: false,
    width: 35,
    height: 35,
    scale: 1,
    rotationInDegrees: 0,
  },
  data: {
    type: 'SvgShape',
  },
  props: {
    type: 'SvgShapeProperties',
    maintainAspectRatio: true,
  },
  scopedLayouts: {},
  style: {
    type: 'ComponentStyle',
    style: {
      groups: {},
      properties: {
        'alpha-fillcolor': '1',
        'alpha-stroke': '1',
        fillcolor: '#000000',
        stroke: '#ED1566',
        strokewidth: '0px',
      },
      propertiesSource: {
        fillcolor: 'value',
        stroke: 'value',
        strokewidth: 'value',
      },
    },
    componentClassName: 'wysiwyg.viewer.components.PopupCloseIconButton',
    styleType: 'custom',
    skin: 'svgshape.v2.Svg_9a8686831e874878a55a90925c0feb6c',
  },
  layouts: {
    type: 'SingleLayoutData',
    componentLayout: {
      type: 'ComponentLayout',
      width: {
        type: 'px',
        value: 35,
      },
      height: {
        type: 'auto',
      },
      minWidth: {
        type: 'px',
        value: 0,
      },
      minHeight: {
        type: 'px',
        value: 0,
      },
      maxWidth: {
        type: 'px',
        value: 99999,
      },
      hidden: false,
    },
    itemLayout: {
      id: '',
      type: 'GridItemLayout',
      gridArea: {
        rowStart: 1,
        rowEnd: 2,
        columnStart: 1,
        columnEnd: 2,
      },
      margins: {
        left: {
          type: 'px',
          value: 0,
        },
        bottom: {
          type: 'px',
          value: 0,
        },
        right: {
          type: 'px',
          value: 16,
        },
        top: {
          type: 'px',
          value: 16,
        },
      },
      justifySelf: 'end',
      alignSelf: 'start',
    },
  },
};
